import RequestEcom from "../RequestEcom";

const BaseEcomServices = {
    isContainPage: () => {
        let excludes = ["/login", "/register", "/forgot-password", "/waiting-for-verification", "/af", "/login-social-callback", "/print-editor"];
        let isHomepage = window.location.pathname === "/";
        let isContain = excludes.some((x) => window.location.href.includes(x)) || isHomepage;
        return isContain;
    },
    Get: async (url) => {
        try {
            const res = await RequestEcom.Get(url);
            if (res.success) return [null, res.data];
            return [null, res];
        } catch (err) {
            return [err, null];
        }
    },
    Post: async (url, params) => {
        try {
            const res = await RequestEcom.Post(url, params);
            if (res.success) return [null, res.data];
            return [null, res];
        } catch (err) {
            return [err, null];
        }
    },
    Delete: async (url) => {
        try {
            const res = await RequestEcom.Delete(url);
            if (res.success) return [null, res.data];
            return [res, null];
        } catch (err) {
            return [err, null];
        }
    },
};

export default BaseEcomServices;
